import DisguisedFaceEmoji from '#/src/static/img/disguised-face.png';
import SecondPlaceMedalEmoji from '#/src/static/img/second-place-medal.png';
import SunglassesEmoji from '#/src/static/img/sunglasses.png';
import ThirdPlaceMedalEmoji from '#/src/static/img/third-place-medal.png';
import TopEmoji from '#/src/static/img/top.png';

import CommonBoat from '#/src/static/img/boats/common_boat.png';

import { BOAT_ICONS_BY_PLACE } from './constants'
import { RATING_ICONS } from '../constants'

const getBoatIcon = (place) => {
    if (place in BOAT_ICONS_BY_PLACE) {
        return BOAT_ICONS_BY_PLACE[place];
    }

    return CommonBoat;
};

export const getPlaceIconProps = ({
  place,
  isCurrent,
  currentPlace,
  ratingIcon,
}) => {
    // Иконку лодки отображаем только для типа RatingIcon.Boat и для первых
    // 20 мест рейтинга для остальных - эмоджи
    if (ratingIcon === RATING_ICONS.boat && place <= 20) {
        const Icon = getBoatIcon(place);

        return {
            iconSrc: Icon,
            iconWidth: 40,
            iconHeight: 30,
        };
    }

    // Случай с 1 местом не обрабатывается, т.к. в этом случае будет показан подиум
    if (place === 2) {
        return {
            iconSrc: SecondPlaceMedalEmoji,
        };
    }

    if (place === 3) {
        return {
            iconSrc: ThirdPlaceMedalEmoji,
        };
    }

    if (isCurrent) {
        return {
            iconSrc: TopEmoji,
        };
    }

    const isPositivePlace = place < currentPlace;
    const iconSrc = isPositivePlace ? SunglassesEmoji : DisguisedFaceEmoji;

    return {
        iconSrc,
    };
};
